import { apiService } from '.';
import { TOKEN } from '../contexts/authContext';

export const asyncPostLoadBase = (
    formdata: any,
    loadOnlyInDB: boolean,
    deleteAndSave: boolean
) => {
    return apiService.post(
        '/api/users-creation',
        formdata,
        {
            loadOnlyInDB: loadOnlyInDB ? '1' : '0',
            deleteAndSave: deleteAndSave ? '1' : '0',
        },
        {
            accept: '*/*',
            Authorization: 'Bearer ' + sessionStorage.getItem(TOKEN),
        }
    );
};
